import { defineComponent as _defineComponent } from 'vue'
import { ref, useTemplateRef, watch, computed } from 'vue';
    import { create_registration_token } from '../../module/users/module';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'create_registration_token',
  props: ['user_id', 'open'],
  setup(__props, { expose: __expose }) {
  __expose();

    let props = __props

    let dat_registration_url = ref('')
    let dat_loading = ref(false)

    const ref_dialog = useTemplateRef('dialog')

    const reset_component = function() {
        dat_registration_url.value = ""
    }
    
    let com_open = computed(() => {
        return props.open
    })

    watch(com_open, async () => {
        console.log('ashkdkjdfs')
        const loc_dialog: HTMLDialogElement | null = ref_dialog.value

        if (loc_dialog === null) {
            return
        }

        loc_dialog.showModal()
        await create_token()
    })

    const create_token = async function() {
        dat_loading.value = true
        dat_registration_url.value = await create_registration_token(props.user_id) ?? ""
        dat_loading.value = false
    }

    const done = function () {
        reset_component()

        const loc_dialog: HTMLDialogElement | null = ref_dialog.value
        
        if (loc_dialog === null) {
            return
        }

        loc_dialog.close()
    }

    // Copy the registration URL to the clipboard
    const copyToClipboard = async function() {
        if (dat_registration_url.value) {
            try {
                await navigator.clipboard.writeText(dat_registration_url.value);
            } catch (error) {
                console.error("Failed to copy: ", error);
            }
        }
    }

const __returned__ = { get props() { return props }, set props(v) { props = v }, get dat_registration_url() { return dat_registration_url }, set dat_registration_url(v) { dat_registration_url = v }, get dat_loading() { return dat_loading }, set dat_loading(v) { dat_loading = v }, ref_dialog, reset_component, get com_open() { return com_open }, set com_open(v) { com_open = v }, create_token, done, copyToClipboard }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})